var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form-item',[_c('objects-inline',{ref:"userFace",attrs:{"target":"user","editable":"","show-id":"","id":_vm.form.item.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }